import { ClioDevCredentials } from './types';

export const clioDevPortal: {
    credentials: ClioDevCredentials;
} = {
    credentials: {
        appId: "14020",
        clientId: "i8ZcKpbg28QhPU9Wf0wONrVWTk88OZ2NY3WwNDym",
        clientSecret: "rqXNNVGi5BPXIKfGmKq6Wr10h2wME5hTUBJqpEWT",
    },
}